import "./lib/jquery_setup";
import initializeEnvBar from "./utils/envBar";
import "./service_introduction/customerStories";

initializeEnvBar();
